// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SalesTable"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [{
    key: "AccountNum",
    label: "供应商编码",
    sortable: true,
  },
  {
    key: "ItemId",
    label: "物料编号",
    sortable: true
  },
  {
    key: "VariantName",
    label: "变型名称",
    sortable: true
  },
  {
    key: "Amount",
    label: "初始含税价",
    sortable: true
  },
  {
    key: "CurrencyCode",
    label: "币种",
    sortable: true
  },
  {
    key: "FromDate",
    label: "开始日期",
    sortable: true,
    type: "date"
  },
  {
    key: "ToDate",
    label: "结束日期",
    sortable: true,
    type: "date"
  },
  {
    key: "QuantityAmountFrom",
    label: "数量开始",
    sortable: true
  },
  {
    key: "QuantityAmountTo",
    label: "数量结束",
    sortable: true
  },
  {
    key: "Remark",
    label: "价格备注",
    sortable: true
  }
  ]

}

///前端验证
const rules = {
}

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const methods = {
  //#region 订单主档相关
  ///get salesorder
  async getData(_params) {
    let _fields = _.map(fields.default, "key")

    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //保存导入
  async SavePurchaseQuoteExport(json) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "generate_InitVendPurchaseQuote", {}, {}
    )
    let result = await code_biz_data
      .execAction({
        params: {
          json: json
        },
        fields: []
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///save salesorder
  async savePurchPrice(data) {

    const biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_Vend_Purchase_Price", create, descriptor
    )
    let _actions = []
    for (var i in data) {
      let sum = 0
      delete data[i]._current
      delete data[i]._id
      delete data[i]._selected
      if (data[i].QuantityAmountFrom == "") {
        delete data[i].QuantityAmountFrom
      }
      if (data[i].QuantityAmountTo == "") {
        delete data[i].QuantityAmountTo
      }
      if (data[i].ToDate == "") {
        delete data[i].ToDate
      }
      if (data[i].FromDate == "") {
        delete data[i].FromDate
      }
      data[i].AccountNum = data[i].AccountNum.toString()
      data[i].ItemId = data[i].ItemId.toString()
      //有成本在保存此项
      if (sum != 0) {

        data[i].Cost_Sum = parseFloat(parseFloat(sum).toFixed(6))
      }

      _actions.push(
        biz_data
          .insertAction({
            params: data[i],
            fields: ["id"]
          })
          .action({})
      )
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data
    } else {
      return null
    }
  },


  //#endregion

  //#region 订单明细相关
  // 获取供应商
  async getCustInfo(items) {
    const cust_biz_data = new biz_data_helper.base_entity_helper(
      "SEI_VendTable", create, descriptor
    )
    let custs = []
    _.each(items, t => {
      custs.push(t.AccountNum.toString())
    })
    _
    let result = await cust_biz_data.selectAction({
      params: {
        AccountNum: {
          "in": custs
        },
      },
      fields: _.map(fields.cust_fields, "key")
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //getgetNameAlias 获取物料名称
  async getNameAlias(items) {
    const item_biz_data = new biz_data_helper.base_entity_helper(
      "SEI_InventTable", create, descriptor
    )
    let ItemIds = []
    _.each(items, t => {
      ItemIds.push(t.ItemId.toString())
    })
    let result = await item_biz_data
      .selectAction({
        params: {
          ItemId: {
            "in": ItemIds
          },
        },
        fields: _.map(fields.inventTable_fields, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  ///get so items
  async getItemData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine",
      create,
      descriptor
    )
    let _fields = _.map(fields.detail_fields, "key")
    _fields.push("id")
    _fields.push("SalesTable_id")
    // _fields.push("DiscPrice");
    _.remove(_fields, n => {
      return n == "price_state"
    })
    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },


  ///del so items
  async deleteItemData(items) {
    let _actions = []

    let item_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine",
      create,
      descriptor
    )

    _.each(items, t => {
      _actions.push(
        item_biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  }
  //#endregion
}
export {
  biz_data, fields,
  methods,
  rules
};

